import React, { useState } from 'react';
import Styles from './mobile-modal.module.scss';
import SiriusModal from '@lingxi-common-component/sirius-ui/SiriusModal';
import Button from '@lingxi-common-component/sirius-ui/Button';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { apis, apiHolder as api, getIn18Text } from 'api';
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
const EmailUnBlockingModal = props => {
    const { visible, onClose, onSuccess, onCancel } = props;
    const [hasSendEmailToAdmin, setHasSendEmailToAdmin] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const sendEmailToAdmin = () => {
        if (hasSendEmailToAdmin)
            return;
        setIsSending(true);
        loginApi
            .sendUnBlockingEmailToAdmin()
            .then(res => {
            if (res.success) {
                setHasSendEmailToAdmin(true);
                onSuccess && onSuccess();
            }
            else {
                Modal.error({
                    content: res.errMsg,
                    maskClosable: false,
                    hideCancel: true,
                    okText: '知道了',
                });
            }
        })
            .finally(() => {
            setIsSending(false);
        });
    };
    if (!visible) {
        return null;
    }
    return (React.createElement(SiriusModal, { width: 640, onCancel: () => {
            onClose && onClose();
        }, visible: visible, footer: null, maskClosable: false },
        React.createElement("div", { className: Styles.mainWrapper },
            React.createElement("div", { className: Styles.title }, getIn18Text('ACCOUNT_SPAM_TITLE')),
            React.createElement("div", { className: Styles.descWrapper },
                React.createElement("p", null,
                    getIn18Text('SPAM_EMAIL_DESC_1'),
                    React.createElement("span", { className: Styles.innerError }, getIn18Text('SPAM_CONTACT_ADMIN')),
                    getIn18Text('SPAM_ADMIN_UNLOCK'))),
            React.createElement("div", { className: Styles.imgWrapper },
                React.createElement("div", { className: Styles.adminUnBlockingImg })),
            React.createElement("div", { className: Styles.descWrapper },
                React.createElement("p", null, getIn18Text('SPAM_ADMIN_STEPS'))),
            React.createElement("div", { className: Styles.btns },
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(Button, { onClick: () => {
                            onCancel && onCancel();
                        } }, getIn18Text('QUXIAO')),
                    React.createElement(Button, { btnType: "primary", loading: isSending, onClick: () => {
                            sendEmailToAdmin();
                        } }, hasSendEmailToAdmin ? getIn18Text('SPAM_EMAIL_SENT') : getIn18Text('SPAM_SENDTO_ADMIN')))),
            React.createElement("div", { className: Styles.tips }, getIn18Text('SPAM_EMAIL_TIP')))));
};
export default EmailUnBlockingModal;
